import React, { useState } from 'react';
import { Card, Checkbox, Col, DatePicker, Form, Input, Row, Select } from 'antd';
import { dropdownSize, inputSize, textInputSize } from '../../../Shared/UI/jsx';
import { SearchOutlined } from '@ant-design/icons';
import { FormDescription } from '../../../Shared/Consts/FormDescription';
import { disciplineOptions } from '../../../Shared/Consts/Dropdowns';

const { Item } = Form;
const { Option } = Select;
const { TextArea } = Input;

const Services = ({ form, formContext }) => {

    return (
        <Form
            form={form}
            size="small"
            layout="vertical"
        >
            <Card size='small' className='formCard'>

                <Row>
                    <Col span={12}>
                        <Item name="referralStatus" label="Referral Status">
                            <Select
                                style={inputSize}
                                disabled
                                showSearch
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                <Option value="0">Open</Option>
                                <Option value="1">Completed</Option>
                                <Option value="2">Partial</Option>
                            </Select>
                        </Item>
                    </Col>
                    <Col span={12}>
                        <Item name="serviceCoordinatorId" label="Service Coordinator">
                            <Input disabled style={inputSize}/>
                        </Item>
                        {formContext && formContext.SC ? (
                            <FormDescription description={formContext.SC.preferredName + " " + formContext.SC.lastName} />
                        ) : null}
                    </Col>
                    <Col span={12}>
                        <Item name="serviceCoordinatorNotes" label="Service Coordinator Notes">
                            <TextArea disabled style={textInputSize} />
                        </Item>
                    </Col>
                    <Col span={12}>
                        <Item name="edTeamId1" label="Ed Team">
                            <Input disabled style={inputSize}/>
                        </Item>
                        {formContext && formContext.EdTeamOne ? (
                            <FormDescription description={formContext.EdTeamOne.preferredName + " " + formContext.EdTeamOne.lastName} />
                        ) : null}
                    </Col>
                    <Col span={12}>
                        <Item name="edTeamId2" label="Ed Team">
                            <Input disabled style={inputSize}/>
                        </Item>
                        {formContext && formContext.EdTeamTwo ? (
                            <FormDescription description={formContext.EdTeamTwo.preferredName + " " + formContext.EdTeamTwo.lastName} />
                        ) : null}
                    </Col>
                    <Col span={12}>
                        <Item name="edTeamId3" label="Ed Team">
                            <Input disabled style={inputSize}/>
                        </Item>
                        {formContext && formContext.EdTeamThree ? (
                            <FormDescription description={formContext.EdTeamThree.preferredName + " " + formContext.EdTeamThree.lastName} />
                        ) : null}
                    </Col>
                    <Col span={12}></Col>
                    <Col span={12}>
                        <Item name="virtualVisit" valuePropName="checked">
                            <Checkbox disabled>
                                Virtual Visit?
                            </Checkbox>
                        </Item>
                    </Col>
                    <Col span={12}>
                        <Item name="dTConsult" label="Developmental Therapy Consult">
                            <DatePicker disabled format="MM/DD/YYYY" style={inputSize} />
                        </Item>
                    </Col>
                    <Col span={12}>
                        <Item name="oTConsult" label="Occupational Therapy Consult">
                            <DatePicker disabled format="MM/DD/YYYY" style={inputSize} />
                        </Item>
                    </Col>
                    <Col span={12}>
                        <Item name="pTConsult" label="Physical Therapy Consult">
                            <DatePicker disabled format="MM/DD/YYYY" style={inputSize} />
                        </Item>
                    </Col>
                    <Col span={12}>
                        <Item name="sTConsult" label="Speech Therapy Consult">
                            <DatePicker disabled format="MM/DD/YYYY" style={inputSize} />
                        </Item>
                    </Col>
                    <Col span={12}>
                        <Item name="dTNeeded" valuePropName="checked">
                            <Checkbox disabled>
                                Developmental Therapy NPA
                            </Checkbox>
                        </Item>
                    </Col>
                    <Col span={12}>
                        <Item name="dTFulfilled" valuePropName="checked">
                            <Checkbox disabled>
                                Developmental Therapy Fulfilled
                            </Checkbox>
                        </Item>
                    </Col>
                    <Col span={12}>
                        <Item name="oTNeeded" valuePropName="checked">
                            <Checkbox disabled>
                                Occupational Therapy NPA
                            </Checkbox>
                        </Item>
                    </Col>
                    <Col span={12}>
                        <Item name="oTFulfilled" valuePropName="checked">
                            <Checkbox disabled>
                                Occupational Therapy Fulfilled
                            </Checkbox>
                        </Item>
                    </Col>
                    <Col span={12}>
                        <Item name="pTNeeded" valuePropName="checked">
                            <Checkbox disabled>
                                Physical Therapy NPA
                            </Checkbox>
                        </Item>
                    </Col>
                    <Col span={12}>
                        <Item name="pTFulfilled" valuePropName="checked">
                            <Checkbox disabled>
                                Physical Therapy Fulfilled
                            </Checkbox>
                        </Item>
                    </Col>
                    <Col span={12}>
                        <Item name="sTNeeded" valuePropName="checked">
                            <Checkbox disabled>
                                Speech Therapy NPA
                            </Checkbox>
                        </Item>
                    </Col>
                    <Col span={12}>
                        <Item name="sTFulfilled" valuePropName="checked">
                            <Checkbox disabled>
                                Speech Therapy Fulfilled
                            </Checkbox>
                        </Item>
                    </Col>
                    <Col span={12}>
                        <Item name="dTAFulfilled" valuePropName="checked">
                            <Checkbox disabled>
                                DTA Fulfilled
                            </Checkbox>
                        </Item>
                    </Col>
                    <Col span={12}>
                        <Item name="cOTAFulfilled" valuePropName="checked">
                            <Checkbox disabled>
                                COTA Fulfilled
                            </Checkbox>
                        </Item>
                    </Col>
                    <Col span={12}>
                        <Item name="pTAFulfilled" valuePropName="checked">
                            <Checkbox disabled>
                                PTA Fulfilled
                            </Checkbox>
                        </Item>
                    </Col>
                    <Col span={12}>
                        <Item name="sLPCFFulfilled" valuePropName="checked">
                            <Checkbox disabled>
                                SLPCF Fulfilled
                            </Checkbox>
                        </Item>
                    </Col>
                    <Col span={12}>
                        <Item name="initialReferralDate" label="Initial Referral">
                            <DatePicker disabled format="MM/DD/YYYY" style={inputSize} />
                        </Item>
                    </Col>
                    <Col span={12}>
                        <Item name="consultReferral1Date" label="Consult Referral">
                            <DatePicker disabled format="MM/DD/YYYY" style={inputSize} />
                        </Item>
                    </Col>
                    <Col span={12}>
                        <Item name="consultReferral2Date" label="Consult Referral 2">
                            <DatePicker disabled format="MM/DD/YYYY" style={inputSize} />
                        </Item>
                    </Col>
                    <Col span={12}>
                        <Item name="consultReferral3Date" label="Consult Referral 3">
                            <DatePicker disabled format="MM/DD/YYYY" style={inputSize} />
                        </Item>
                    </Col>
                    <Col span={12}>
                        <Item name="consultReferral4Date" label="Consult Referral 4">
                            <DatePicker disabled format="MM/DD/YYYY" style={inputSize} />
                        </Item>
                    </Col>
                    <Col span={12}>
                        <Item name="ongoingReferral1Date" label="Ongoing Referral">
                            <DatePicker disabled format="MM/DD/YYYY" style={inputSize} />
                        </Item>
                    </Col>
                    <Col span={12}>
                        <Item name="ongoingReferral2Date" label="Ongoing Referral 2">
                            <DatePicker disabled format="MM/DD/YYYY" style={inputSize} />
                        </Item>
                    </Col>
                    <Col span={12}>
                        <Item name="ongoingReferral3Date" label="Ongoing Referral 3">
                            <DatePicker disabled format="MM/DD/YYYY" style={inputSize} />
                        </Item>
                    </Col>
                    <Col span={12}>
                        <Item name="ongoingReferral4Date" label="Ongoing Referral 4">
                            <DatePicker disabled format="MM/DD/YYYY" style={inputSize} />
                        </Item>
                    </Col>
                    <Col span={12}>
                        <Item name="addonReferral1Date" label="Addon Referral">
                            <DatePicker disabled format="MM/DD/YYYY" style={inputSize} />
                        </Item>
                    </Col>
                    <Col span={12}>
                        <Item name="addonReferral2Date" label="Addon Referral 2">
                            <DatePicker disabled format="MM/DD/YYYY" style={inputSize} />
                        </Item>
                    </Col>
                    <Col span={12}>
                        <Item name="addonReferral3Date" label="Addon Referral 3">
                            <DatePicker disabled format="MM/DD/YYYY" style={inputSize} />
                        </Item>
                    </Col>
                    <Col span={12}>
                        <Item name="addonReferral4Date" label="Addon Referral 4">
                            <DatePicker disabled format="MM/DD/YYYY" style={inputSize} />
                        </Item>
                    </Col>
                    <Col span={12}>
                        <Item name="caseManagementNotes" label="Case Management Notes">
                            <TextArea disabled style={textInputSize} />
                        </Item>
                    </Col>
                    <Col span={12}>
                        <Item name="supplementalDate1" label="Change Page Date">
                            <DatePicker disabled format="MM/DD/YYYY" style={inputSize} />
                        </Item>
                    </Col>
                    <Col span={12}>
                        <Item name="supplementalService1" label="Supplemental Service">
                            <Select
                                style={inputSize}
                                disabled
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                {disciplineOptions.map(opt => (
                                    <Option key={opt.value} value={opt.value}>
                                        {opt.label}
                                    </Option>
                                ))}
                            </Select>
                        </Item>
                    </Col>
                    <Col span={12}>
                        <Item name="supplementalDate2" label="Change Page Date 2">
                            <DatePicker disabled format="MM/DD/YYYY" style={inputSize} />
                        </Item>
                    </Col>
                    <Col span={12}>
                        <Item name="supplementalService2" label="Supplemental Service 2">
                            <Select
                                style={dropdownSize}
                                disabled
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                {disciplineOptions.map(opt => (
                                    <Option key={opt.value} value={opt.value}>
                                        {opt.label}
                                    </Option>
                                ))}
                            </Select>
                        </Item>
                    </Col>
                    <Col span={12}>
                        <Item name="supplementalDate3" label="Change Page Date 3">
                            <DatePicker disabled format="MM/DD/YYYY" style={inputSize} />
                        </Item>
                    </Col>
                    <Col span={12}>
                        <Item name="supplementalService3" label="Supplemental Service 3">
                            <Select
                                style={dropdownSize}
                                disabled
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                {disciplineOptions.map(opt => (
                                    <Option key={opt.value} value={opt.value}>
                                        {opt.label}
                                    </Option>
                                ))}
                            </Select>
                        </Item>
                    </Col>
                    <Col span={12}>
                        <Item name="supplementalDate4" label="Change Page Date 4">
                            <DatePicker disabled format="MM/DD/YYYY" style={inputSize} />
                        </Item>
                    </Col>
                    <Col span={12}>
                        <Item name="supplementalService4" label="Supplemental Service 4">
                            <Select
                                style={dropdownSize}
                                disabled
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                {disciplineOptions.map(opt => (
                                    <Option key={opt.value} value={opt.value}>
                                        {opt.label}
                                    </Option>
                                ))}
                            </Select>
                        </Item>
                    </Col>
                    <Col span={12}>
                        <Item name="doctorSignature" label="Doctor's Signature">
                            <Input disabled style={inputSize} />
                        </Item>
                    </Col>
                    <Col span={12}>
                        <Item name="doctorName" label="Doctor's Name">
                            <Input disabled style={inputSize} />
                        </Item>
                    </Col>
                    <Col span={12}>
                        <Item name="doctorFax" label="Doctor's Fax Number">
                            <Input disabled style={inputSize} />
                        </Item>
                    </Col>
                    <Col>
                        <Item name="doctorPhone" label="Doctor's Phone Number">
                            <Input disabled style={inputSize} />
                        </Item>
                    </Col>
                </Row>
            </Card>
        </Form>
    );
}

export default Services;